// store.selectors.ts
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { StoreState } from '../reducers';

export const selectStoreFeature = createFeatureSelector<StoreState>('store');

export const selectStore = createSelector(selectStoreFeature,(state: StoreState) => state.store);

export const selectStoreLoading = createSelector(selectStoreFeature,(state: StoreState) => state.loading);

export const selectStoreError = createSelector(selectStoreFeature,(state: StoreState) => state.error);

export const selectStoreLoaded = createSelector(selectStore,(storeData) => storeData !== null && Object.keys(storeData).length > 0);

export const selectWorkDay = createSelector(selectStoreFeature,(state: StoreState) => state.workDay);

export const selectStoreLocation = createSelector(selectStoreFeature,(state: StoreState) => state.location);
export const selectStoreLocationLoading = createSelector(selectStoreFeature,(state: StoreState) => state.loading);
export const selectStoreLocationError = createSelector(selectStoreFeature,(state: StoreState) => state.error);

export const selectStoreList = createSelector(selectStoreFeature,(state: StoreState) => state.storeList);

export const selectStoreIsMulti = createSelector(selectStoreFeature,(state: StoreState) => state.isMultiStore);

export const selectStoreListLoading = createSelector(selectStoreFeature,(state: StoreState) => state.loading);
